import { CommonService } from 'app/services/common.service';
import { PartnerDetailService } from './../../services/partner-detail.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { NotificationService } from './../../services/notification.service';
import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ExcelService } from 'app/services';
// import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-admin-report',
  templateUrl: './admin-report.component.html',
  styleUrls: ['./admin-report.component.scss']
})
export class AdminReportComponent implements OnInit {
  @ViewChild('tableData') el: ElementRef;

  @Input() dynamicStudentUserId;
  @Input() studentPartnerId;
  studentUserId: any;
  reportTitleList: any;
  reportTitle = '0';
  selectedUser = [];
  selectedPartner = [];
  selectedState = [];
  selectedProgram = [];
  selectedAccount = [];
  selectedCoach = [];
  selectedEnvisionStatus = [];
  selectedGrade = [];
  showReportPart = false;
  stateData: any;
  statusFlag = false;
  userFlag = false;
  partnerFlag = false;
  gradeFlag = false;
  accountFlag = false;
  programFlag = false;
  stateFlag = false;
  fromDateFlag = false;
  toDateFlag = false;
  coachFlag = false;
  reportFilterList = [];
  criteria: any;
  parameterArr = [];
  coachArray: any;
  toDate;
  fromDate;
  partnerSelectFlag = false;
  generatedReportFlag = false;
  accountArray = [{ value: '1', label: 'Active' }, { value: '0', label: 'Inactive' }];
  envStatusArray = [{ value: '1', label: 'Registered' }, { value: '0', label: 'Unregistered' }];
  stateArray: any;
  generatedReport = [];
  reports = [];
  gradeArray = [];
  programArray = [];
  fetchFlag = false;
  fetchText;
  partnerArray = [];
  lastKey: any;
  showSort = [];
  currentRoute: string;
  loader = false;
  generatedReportExcelData = [];
  colName: string;
  dropdownSettings;
  constructor(
    private notificationService: NotificationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonAuthService: CommonAuthenticationService,
    private _partnerDetailService: PartnerDetailService,
    private _commonService: CommonService,
    private _routes: ActivatedRoute,
    private excelService: ExcelService
  ) { }

  ngOnInit() {

    this.currentRoute = this._routes.snapshot.url[0].path;
    this.studentUserId = this._commonAuthService.getUserId();
    this.getReportTitleList();
    this.getCoachesData();
    this.getPrograms();
    this.getPartnerList();
    this.getStudentGradeLevel();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'label',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //itemsShowLimit: 3,
      allowSearchFilter: false
    };
  }

  getStudentGradeLevel() {
    const selectedType = {
      classTypeName: 'Senior Class Year'
      //
    };
    this._commonRequestResponseService.postWithHeader('admin/values/', selectedType)
      .subscribe(
        (studentGradeLevelList: any) => {
          let gradeYear = parseInt(studentGradeLevelList.items[0].text);
          gradeYear -= 5;
          for (let i = 0; i < 10; i++) {
            this.gradeArray.push({ value: gradeYear + i, label: gradeYear + i });
          }
        },
        () => {
          this.notificationService.show('error', 'Error while fetching student grade level list data');
        });
  }

  getPartnerList() {
    this._partnerDetailService.getPartnerList()
      .subscribe(
        (partnersListJson: any) => {
          this.partnerArray = partnersListJson.items.map(items => {

            return {
              value: items.id,
              label: items.partnerName
            }
          })
          this.partnerArray.push({
            value: 0,
            label: 'Global'
          });
        },
        (error) => {
          console.error(error);
        });
  }

  getPrograms() {
    const getMyCollegeStatusInputJson = {
      classTypeName: 'Service Type'
    };
    this._commonRequestResponseService.postWithHeader('admin/values', getMyCollegeStatusInputJson)
      .subscribe(
        (programsJSON: any) => {
          const programs = programsJSON.items;
          this.programArray = programs.map(items => {

            return {
              value: items.value,
              label: items.text
            }
          });
        },
        () => {
          this.notificationService.show('info', 'No values data exists for this reference type');
        });
  }

  getReportTitleList() {
    this.loader = true;
    const inputJson = {
      studentUserId: this.studentUserId
    };

    this._commonRequestResponseService.post('report/getReports', inputJson)
      .subscribe(
        (reportTitleData: any) => {
          this.loader = false;
          this.reportTitleList = reportTitleData.item;
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  getReportFilter() {
    this.fetchFlag = false;
    this.loader = true;
    const inputJson = {
      ReportId: this.reportTitle
    };

    this.parameterArr = [];
    this.statusFlag = false;
    this.userFlag = false;
    this.partnerFlag = false;
    this.gradeFlag = false;
    this.accountFlag = false;
    this.programFlag = false;
    this.stateFlag = false;
    this.fromDateFlag = false;
    this.toDateFlag = false;
    this.coachFlag = false;

    this.selectedUser = [];
    this.selectedPartner = [];
    this.selectedState = [];
    this.selectedProgram = [];
    this.selectedAccount = [];
    this.selectedCoach = [];
    this.selectedEnvisionStatus = [];
    this.selectedGrade = [];
    this.fromDate = '';
    this.toDate = '';

    this._commonRequestResponseService.post('report/getReportFilter', inputJson)
      .subscribe(
        (reportFilterData: any) => {
          this.getStateData();
          this.loader = false;
          this.reportFilterList = reportFilterData.item;
          for (let i = 0; i < this.reportFilterList.length; i++) {
            if (this.reportFilterList[i].label === 'Status') {
              this.statusFlag = true;
            }
            if (this.reportFilterList[i].label === 'User') {
              this.userFlag = true;
            }
            if (this.reportFilterList[i].label === 'Partner') {
              this.partnerFlag = true;
            }
            if (this.reportFilterList[i].label === 'Grad Year') {
              this.gradeFlag = true;
            }
            if (this.reportFilterList[i].label === 'Account Status') {
              this.accountFlag = true;
            }
            if (this.reportFilterList[i].label === 'Program') {
              this.programFlag = true;
            }
            if (this.reportFilterList[i].label === 'State') {
              this.stateFlag = true;
            }
            if (this.reportFilterList[i].label === 'FromDate') {
              this.fromDateFlag = true;
            }
            if (this.reportFilterList[i].label === 'ToDate') {
              this.toDateFlag = true;
            }
            if (this.reportFilterList[i].label === 'Coach') {
              this.coachFlag = true;
            }
            this.parameterArr.push(this.reportFilterList[i].parameter);
          }
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  saveReportFilter() {
    if (this.selectedPartner.length) {
      this.partnerSelectFlag = false;
      this.criteria = {};
     
      for (let i = 0; i < this.parameterArr.length; i++) {
        if (this.parameterArr[i] === 'partnerId') {
          this.criteria.partnerId = this.selectedPartner.length > 0 ? this.selectedPartner.map(e => e.value).join(',') : null;
        }
        if (this.parameterArr[i] === 'state') {
          this.criteria.state = this.selectedState.length > 0 ? this.selectedState.map(e => e.value).join(',') : null;
        }
        if (this.parameterArr[i] === 'status') {
          this.criteria.status = this.selectedEnvisionStatus.length > 0 ? this.selectedEnvisionStatus.map(e => e.value).join(',') : null;
        }
        if (this.parameterArr[i] === 'accountStatus') {
          this.criteria.accountStatus = this.selectedAccount.length > 0 ? this.selectedAccount.map(e => e.value).join(',') : null;
        }
        if (this.parameterArr[i] === 'gradYear') {
          this.criteria.gradYear = this.selectedGrade.length > 0 ? this.selectedGrade.map(e => e).join(',') : null;
        }
        if (this.parameterArr[i] === 'program') {
          this.criteria.program = this.selectedProgram.length > 0 ? this.selectedProgram.map(e => e.value).join(',') : null;
        }
        if (this.parameterArr[i] === 'coachUserId') {
          this.criteria.coachUserId = this.selectedCoach.length > 0 ? this.selectedCoach.map(e => e.value).join(',') : null;
        }
        if (this.parameterArr[i] === 'fromDate') {
          this.criteria.fromDate = this.fromDate ? this.fromDate : null;
        }
        if (this.parameterArr[i] === 'toDate') {
          this.criteria.toDate = this.toDate ? this.toDate : null;
        }
      }

      const inputJson = {
        ReportId: this.reportTitle,
        criteria: this.criteria
      };
      this.loader = true;
      this._commonRequestResponseService.post('report/fetch', inputJson)
        .subscribe(
          (saveFilterData: any) => {
            this.reportTitleList.filter(data => {
              if (data.id === parseInt(this.reportTitle)) {
                this.fetchText = data.reportName
              }

            })
            this.fetchFlag = true
            this.loader = false;
            this.generatedReport = saveFilterData.item;
            const reports = [];
            for (let i = 0; i < this.generatedReport.length; i++) {
              this.showSort[i] = 'false';
            }

            if (this.generatedReport.length) {
              Object.keys(this.generatedReport[0]).forEach((key) => {
                reports.push(key);
              });
              this.generatedReportFlag = false;
            } else {
              this.generatedReportFlag = true;
            }
            this.reports = reports;
            this.lastKey = this.reports[0];
          },
          () => {
            this.loader = false;
            this.notificationService.show('error', 'Error while calling service');
          });
    } else {
      this.partnerSelectFlag = true;
    }
  }

  getStateData() {
    const selectedType = {
      classTypeName: 'State'
    };
    this._commonRequestResponseService.postWithHeader('admin/values/', selectedType)
      .subscribe(
        (data: any) => {
          this.stateData = data.items;
          this.stateArray = this.stateData.map(items => {
            return {
              value: items.value,
              label: items.text
            }
          });
        },
        () => {
          this.notificationService.show('error', 'Error while fetching data');
        });
  }

  getCoachesData() {
    this._commonRequestResponseService.postWithHeader('shared/GetCoachListForReport', {})
      .subscribe(
        (data: any) => {
          const coachesData = data.items;
          this.coachArray = coachesData.map(items => {
            return {
              value: items.coachID,
              label: items.coachName
            }
          })
        },
        () => {
          this.notificationService.show('error', 'Error while fetching data');
        });
  }
  exportToExcel() {
    this.generatedReportExcelData = [];
    if (this.generatedReport) {
      this.generatedReport.forEach((data) => {
        this.generatedReportExcelData.push(data)
      });
    }
    this.excelService.exportAsExcelFile(this.generatedReportExcelData, this.fetchText);
  }
  sortTable(orderBy, columnName, order) {
    if (orderBy === 'desc') {
      this.colName = '-' + columnName
    } else {
      this.colName = columnName
    }
    this.showSort[order] = !this.showSort[order];
    this.generatedReport.sort(this._commonService.dynamicSort(this.colName, false));
  }

  exportPDF() {
    this.loader = true;
    const htmlData = this.el.nativeElement.innerHTML;

    const selectedType = {
      htmlString: htmlData,
      Location: window.location.origin
      //
    };
    this._commonRequestResponseService.postWithHeader('report/pdfDownload', selectedType)
      .subscribe(
        (response: any) => {
          const samplearray = this.base64ToArrayBuffer(response.pdfBase64String);
          this.saveByteArray(this.fetchText, samplearray);
          this.loader = false;
        },
        () => {
          this.notificationService.show('error', 'Error while fetching student grade level list data');
          this.loader = false;
        });

  }

  saveByteArray(reportName, byte) {
    //var blob = new Blob([byte], { type: "application/pdf"});
    const blob = new Blob([byte], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = reportName;
    link.click();
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }


}
